import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { API_PERSONAL_URL } from 'containers/Checkout/constants'
import { setError, isLoading } from 'containers/Checkout/actions'
import { flattenErrors } from 'utilities/formValidator.util'
import { GA_CATEGORY } from './constants'

export const PERSONAL_SET_FIELDS = 'PERSONAL_SET_FIELDS'
export const PERSONAL_FIELD_ERRORS = 'PERSONAL_SUBMIT_ERRORS'
export const PERSONAL_SUBMIT_SUCCESS = 'PERSONAL_SUBMIT_SUCCESS'
export const PERSONAL_CLEAR_FIELD_ERROR = 'PERSONAL_CLEAR_FIELD_ERROR'

export const MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY = 'MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY'
export const MODEM_DELIVERY_ADDRESS_MANUAL = 'MODEM_DELIVERY_ADDRESS_MANUAL'

export function setModemAddressSameAsDelivery(yesOrNo) {
  return {
    type: MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY,
    payload: yesOrNo,
  }
}

export function setModemDeliveryAddressManual(state) {
  return {
    type: MODEM_DELIVERY_ADDRESS_MANUAL,
    payload: state,
  }
}

export function setFieldValues(fields) {
  return {
    type: PERSONAL_SET_FIELDS,
    payload: fields,
  }
}

function personalSubmitSuccess(newStage, address) {
  return {
    type: PERSONAL_SUBMIT_SUCCESS,
    payload: {
      next: newStage,
      address,
    },
  }
}

export function setFieldErrors(errors) {
  Object.keys(errors).forEach((field) => {
    gaEvent('Invalid', {
      event_category: GA_CATEGORY,
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true,
    })
  })
  return {
    type: PERSONAL_FIELD_ERRORS,
    payload: errors,
  }
}

export function clearFieldError(fieldName) {
  return {
    type: PERSONAL_CLEAR_FIELD_ERROR,
    payload: fieldName,
  }
}

export function loadDetails() {
  return (dispatch) => {
    dispatch(isLoading(true))
    axios
      .get(API_PERSONAL_URL)
      .then((response) => {
        if (response.data.success) {
          dispatch(setFieldValues(response.data.fields))
        } else {
          dispatch(setError(true))
        }
      })
      .catch(() => {
        dispatch(setError(true))
      })
  }
}

export function submitPersonalInfo(data, manualAddress, sameAddressAsDelivery) {
  return (dispatch) => {
    dispatch(setFieldValues(data))
    dispatch(isLoading(true))

    const payload = {
      ...data,
      is_manual_address: manualAddress,
      same_as_delivery_address: sameAddressAsDelivery,
    }

    axios
      .post(API_PERSONAL_URL, payload)
      .then((response) => {
        if (response.data.success) {
          dispatch(personalSubmitSuccess(response.data.next, response.data.address))
          gaEvent('Success', {
            event_category: GA_CATEGORY,
          })
        } else {
          dispatch(setError(true))
          gaEvent('Failed', {
            event_category: GA_CATEGORY,
            event_label: 'Rejected',
          })
        }
      })
      .catch((error) => {
        if (error.response.data && error.response.data.errors) {
          dispatch(setFieldErrors(flattenErrors(error.response.data.errors)))
        } else {
          dispatch(setError(true))
          gaEvent('Failed', {
            event_category: GA_CATEGORY,
            event_label: (error.response && error.response.statusText) || 'Network Error',
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// ./containers/stages/PersonalInfoStage/actions.js